import React, { useCallback, useMemo } from "react";
import { Layout } from "../layout/Layout.js";
import { getComments } from "./commentsApi.js";
import { Comment } from "../../model/comments/Comment.js";
import { requestDeleteJson } from "../../../packages/fetcher/fetcherFunctions.js";
import { useRequiredParameter } from "../../../packages/router/params/useRequiredParameter.js";
import { Column } from "../../../packages/ui/table/quick/Column.js";
import { formatUnixTimestampDate } from "../../../packages/date/dateFunctions.js";
import { Buttons } from "../../../packages/ui/form/Buttons.js";
import { Button } from "../../../packages/ui/button/Button.js";
import { Link } from "../../../packages/router/Link.js";
import { FixedTable } from "../../../packages/ui/table/quick/FixedTable.js";
import { useLoadEffect } from "../../../react/load/useLoadEffect.js";

/**
 * Renders comments page for a post.
 */
export const CommentsPage = () => {
  const postId = useRequiredParameter("postId");

  const result = useLoadEffect(`comments-${postId}`, () => getComments(postId));
  const comments = useMemo(() => (result.state === "success" ? result.data : []), [result]);

  const handleRemove = useCallback(
    async (commentId: string) => {
      if (confirm("Remove comment?")) {
        const url = `/api/comment/${commentId}`;
        await requestDeleteJson(url);
        result.reload();
      }
    },
    [result]
  );

  const columns: Column<Comment>[] = [
    {
      span: 1,
      title: "Author",
      render: (row) => row.author
    },
    {
      span: 1,
      title: "Kuupäev",
      render: (row) => formatUnixTimestampDate(row.timestamp)
    },
    {
      span: 4,
      title: "Kommentaar",
      render: (row) => row.content.substring(0, 200)
    },
    {
      span: 2,
      title: "Tegevus",
      render: (row) => (
        <Buttons>
          <Button size="small" onClick={() => handleRemove(row.id)}>
            Kustuta
          </Button>
          <Link to={`/comment/${row.id}`} className="button small print-none">
            Muuda
          </Link>
        </Buttons>
      )
    }
  ];

  return (
    <Layout title="Blogi kommentaarid" containerWidth="fixed-wide-min">
      <h2>Blogi kommentaarid</h2>
      <FixedTable columns={columns} rows={comments} fontSize="tiny" />
    </Layout>
  );
};
